import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { FIELDS } from './validation/fields';
import AppInput from '../AppInput';
import ReCAPTCHA from '../ReCaptcha';
import Message from '../Message';
import MotiveTitle from '../../views/Contact/Motive/MotiveTitle';
import { validateRutGoldSilver } from '../../../redux/actions/RutsActions';
import { resetValidation } from '../../../redux/slices/RutsSlice';
import { setIsValidReCaptcha } from '../../../redux/slices/reCaptchaSlice';
import { textMapper } from '../../../helpers/FormHelper';
import { useFormStyles } from './styles';
import LoadingButton from '../LoadingButton';
import ProductList from './ProductList';
import { getProducts } from '../../../redux/actions/ProductsActions';
import { schema } from './validation/schema';
import { INSERT_MAIN_DATA } from '../../../constants/texts';

const Form = ({ ...props }) => {
  const { state, onData, valid, mobile, motiveId, issueFormName } = props;

  const dispatch = useDispatch();
  const classes = useFormStyles();
  const { validationStatus, errorMessageGold } = useSelector(
    (state) => state.rutsReducer,
  );
  const { getStatus, products, errorMessage } = useSelector(
    (state) => state.productsReducer,
  );
  const { reCaptchaToken, isValidReCaptcha } = useSelector(
    (state) => state.reCaptchaSlice,
  );
  const [showOcCaptcha, setShowOcCaptcha] = useState(false);

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });

    let fieldsValidate = schema.validate({ [e.target.name]: e.target.value });
    if ('error' in fieldsValidate) {
      setShowOcCaptcha(false);
      resetCaptcha();
    } else setShowOcCaptcha(true);
  };

  const handleBlur = () => {
    if (valid) {
      dispatch(
        validateRutGoldSilver({ motive: motiveId, rut: state?.rut?.value }),
      );
    }
  };

  useEffect(() => {
    if (!valid) dispatch(resetValidation());
    else
      dispatch(
        validateRutGoldSilver({ motive: motiveId, rut: state?.rut?.value }),
      );
  }, [valid]);

  const onClick = () => {
    const oc = state['orderId'].value;
    if (valid) dispatch(getProducts({ oc, reCaptchaToken }));
  };

  useEffect(() => {
    if (getStatus === 'error' || validationStatus === 'error') resetCaptcha();
  }, [getStatus, validationStatus]);

  const resetCaptcha = () => {
    dispatch(setIsValidReCaptcha(false));
  };

  return (
    <React.Fragment>
      {mobile && (
        <React.Fragment>
          <MotiveTitle
            icon={textMapper.get(motiveId).icon}
            title={textMapper.get(motiveId).title}
            subtitle={textMapper.get(motiveId).subtitle}
            mobile={mobile}
          />
          <Typography className={classes.title}>{INSERT_MAIN_DATA}</Typography>
        </React.Fragment>
      )}
      {FIELDS.map((field, index) => (
        <AppInput
          issueFormName={issueFormName}
          key={index}
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={() => {}}
          disabled={state[field.name]?.disabled || false}
          name={field.name}
          error={state[field.name]?.error || false}
          type={state[field.name]?.type || ''}
          label={state[field.name]?.label || ''}
          required={state[field.name]?.required || false}
          inputAdornment={state[field.name]?.inputAdornment || ''}
          success={state[field.name]?.success || ''}
          helperText={state[field.name]?.helper || ''}
          errorMessage={state[field.name]?.message || ''}
        />
      ))}
      {showOcCaptcha &&
        validationStatus !== 'error' &&
        getStatus !== 'succeded' && (
          <React.Fragment>
            <ReCAPTCHA />
            <LoadingButton
              name="GetProductList"
              onClick={onClick}
              variant="contained"
              color="primary"
              text="Consultar"
              disabled={!valid || !isValidReCaptcha}
            />
          </React.Fragment>
        )}
      {getStatus === 'loading' && (
        <Box marginTop="26px" display="flex" justifyContent="center">
          <CircularProgress color="primary" />
        </Box>
      )}
      {getStatus === 'succeded' && validationStatus !== 'error' && valid && (
        <ProductList
          motiveId={motiveId}
          products={products}
          orderId={state['orderId']?.value || ''}
          mobile={mobile}
          state={state}
          issueFormName={issueFormName}
        />
      )}
      {validationStatus === 'error' && (
        <Box marginTop="26px">
          <Message severity="info" message={errorMessageGold} fullRounded />
        </Box>
      )}
      {getStatus === 'error' && (
        <Box marginTop="26px">
          <Message severity="alert" message={errorMessage} fullRounded />
        </Box>
      )}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  valid: PropTypes.bool,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueFormName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default Form;
